import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import MustWatch from "./components/MustWatch";
import HighRated from "./components/HighRated";
import Trending from "./components/Trending";
import GenreExplorer from "./components/GenreExplorer";
import ScenarioPicks from "./components/ScenarioPicks";
import NewReleases from "./components/NewReleases";
import ViewingGuide from "./components/ViewingGuide";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <MustWatch />
        <HighRated />
        <Trending />
        <GenreExplorer />
        <ScenarioPicks />
        <NewReleases />
        <ViewingGuide />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}